"use client";

import {JSX, ReactNode} from "react";

import {TripHelpButton} from "@/sections/trip/help-panel";

import type {TripUnitPmsPropertyManagement} from "@/entities/trip/api/types";

import {useTranslation} from "@/shared/i18n";
import {ArrowRightIcon} from "@/shared/ui/icons/navigation/arrow-right-icon";

import "./styles/trip-mobile-header.scss";

export interface TripMobileHeaderProps {
    support: TripUnitPmsPropertyManagement;
    title?: ReactNode;
    onBack?: () => void;
    onOpenMenu?: () => void;
}

export function TripMobileHeader({support, title, onBack, onOpenMenu}: TripMobileHeaderProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <header className="trip-mobile-header">
            <div className="trip-mobile-header__leading">
                {onOpenMenu && (
                    <button type="button" className="trip-mobile-header__hamburger" onClick={onOpenMenu} aria-label={t("trip.openMenu")}>
                        <span />
                        <span />
                        <span />
                    </button>
                )}
                {onBack && (
                    <button type="button" className="trip-mobile-header__back" onClick={onBack} aria-label={t("trip.back")}>
                        <ArrowRightIcon width={18} height={18} style={{transform: "rotate(180deg)"}} />
                    </button>
                )}
                {title && <span className="trip-mobile-header__title">{title}</span>}
            </div>
            <TripHelpButton support={support} />
        </header>
    );
}
